import { useContext } from "react";

import { FormType } from "@simplyk/common";

import { useTranslate } from "../../../../hooks/useTranslate";
import { useFormV2Context } from "../../context/FormV2Context";
import { useEnterKeyListener } from "../../hooks/useEnterKeyListener";

import { useAuctionFirstStepSubmit } from "./useAuctionFirstStepSubmit";

import { HeartsAnimationContext } from "@/features/FormV2/context/heartsAnimationContext";
import { HeartsFormButton } from "@/forms-design-system/HeartsFormButton";
import { ArrowRight } from "@/icons/outlined";

export const AuctionCheckoutFooter = () => {
  const { t } = useTranslate();
  const { currentStep } = useFormV2Context(FormType.Ticketing);
  const { onFirstStepSubmit, canSubmitFirstStep } = useAuctionFirstStepSubmit();
  const { shouldDisplayHeartsAnimation, animationKey } = useContext(HeartsAnimationContext);

  useEnterKeyListener(onFirstStepSubmit, currentStep === "selection");

  return (
    <HeartsFormButton
      type="submit"
      endIcon={<ArrowRight />}
      onClick={onFirstStepSubmit}
      disabled={!canSubmitFirstStep}
      data-test="form-v2-step1-submit-button"
      animated={shouldDisplayHeartsAnimation}
      animationKey={animationKey}
      autoplay
      sx={(theme) => ({
        boxShadow: theme.shadows[2],
      })}
    >
      {t("donationForm", "continue")}
    </HeartsFormButton>
  );
};
